import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from '@phosphor-icons/react';

const ProductDirectory = () => {
  const products = [
    { name: 'Access Tokens', price: '$5', description: 'Talk to any mind' },
    { name: 'Truth Gate', price: '$5', description: 'Verify a claim' },
    { name: 'SIM Generation', price: '$10', description: 'Custom AI persona' },
    { name: 'HumanCodex', price: '$15', description: 'The full doctrine' },
    { name: 'Consultation', price: '$25', description: 'Private 1-hour' },
    { name: 'Federation Merch', price: 'Varies', description: 'T-shirts & more' }
  ];

  const scrollToProducts = () => {
    const element = document.getElementById('chamber-products');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.5 }}
      className="w-full"
    >
      <div className="glass-surface border-2 border-[#FFB800]/40 rounded-xl p-8 shadow-2xl">
        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <span className="text-3xl">🗺️</span>
          <h2 className="text-2xl sm:text-3xl font-black text-white">WHAT'S IN STORE</h2>
        </div>

        {/* Directory List */}
        <div className="space-y-3 mb-6">
          {products.map((product, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.4, delay: 0.6 + idx * 0.1 }}
              onClick={scrollToProducts}
              className="flex items-center justify-between group cursor-pointer hover:bg-white/5 p-2 rounded-lg transition-all"
            >
              <div className="flex items-center gap-3 flex-1">
                <span className="text-[#00F0FF] text-lg">◈</span>
                <span className="font-bold text-white group-hover:text-[#00F0FF] transition-colors">
                  {product.name}
                </span>
                <span className="text-[#FFB800] font-bold">({product.price})</span>
              </div>
              
              {/* Dot leader */}
              <div className="hidden sm:flex flex-1 items-center px-4">
                <div className="flex-1 border-b border-dotted border-gray-600 group-hover:border-[#00F0FF]/40 transition-colors"></div>
              </div>

              <span className="text-gray-400 text-sm group-hover:text-white transition-colors">
                {product.description}
              </span>
            </motion.div>
          ))}
        </div>

        {/* You Are Here Marker */}
        <motion.div
          animate={{
            scale: [1, 1.05, 1],
            opacity: [0.8, 1, 0.8]
          }}
          transition={{
            duration: 2,
            repeat: Infinity,
            ease: "easeInOut"
          }}
          className="flex items-center gap-2 p-4 glass-card border border-[#FFB800]/40 rounded-lg"
        >
          <MapPin size={24} weight="fill" className="text-[#FFB800]" />
          <span className="font-bold text-[#FFB800]">You are in:</span>
          <span className="text-white font-bold">THE ORACLE'S MARKETPLACE</span>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ProductDirectory;
